import $ from 'jquery';

export default function bind() {
  const $input = $('.file.input');

  $input.find('input:text, .ui.upload.button').on('click', evt => {
    const $file = $(evt.target)
      .closest('.file.input')
      .find('input[type="file"]');

    $file.off('change').on('change', evt => {
      const file = evt.target.files[0];
      if (file) {
        const $name = $(evt.target)
          .closest('.file.input')
          .find('input[type="text"]');

        // Setting file name in input text
        $name.val(file.name);
      }
    });

    // Triggering file input selector
    $file.click();
  });

  $input.find('.ui.remove.button').on('click', evt => {
    evt.preventDefault();

    const $container = $(evt.target).closest('.file.input');

    // Clearing inputs
    const $text = $container.find('input[type="text"]');
    const $id = $container.find('input[type="hidden"]');

    $text.val('');
    $id.remove();

    // Removing button too
    $(evt.target).remove();
  });
}



// WEBPACK FOOTER //
// ./src/plugins/files.js